module.exports = __webpack_public_path__ + "static/media/bg-about2.61f9ef3a.png";